import React from "react";
import './Header2.css';
import {Link} from "react-router-dom";
import {useState} from 'react';
import HamburgerMenuOpen from './source/hamburgermenuopen.png';
import HamburgerMenuClose from './source/hamburgermenuclose.png';



function Header2() {

const [toggleMenu, setToggleMenu] = useState(false);

  return (

    <div className="header2">
      <div className="header2-box1">
        <div className="header2-box2">
         <div className="header2-box3">
         MIROSLAV ŽAJGLA
         </div>
         <div className="header2-box4">
         SÁDROKARTONY
         </div>
        </div>

       <div className="header-box5-menu">
          <div className="header-box5-menu-ul">
            <div className="header-box5-menu-li"><a href="*"><Link to="/">ÚVOD</Link></a></div>
            <div className="header-box5-menu-li"><a href="*"><Link to="/PageSluzby">NABÍDKA SLUŽEB</Link></a></div>
           <div className="header-box5-menu-li"><a href="*"><Link to="/PageProjekty">PROJEKTY</Link></a></div>
           <div className="header-box5-menu-li"><a href="*"><Link to="/PageCertifikaty">CERTIFIKÁTY</Link></a></div>
           <div className="header-box5-menu-li"><a href="*"><Link to="/PageKontakt">KONTAKT</Link></a></div>
         </div>  
       </div>



      </div>
      
      <div className="menu-ul-small"><img src={HamburgerMenuOpen} alt="logo" onClick={() => setToggleMenu(true)}/>
          {toggleMenu && (
                          <div className='menu-ul-small-overlay'>
                            <div className="menu-ul-small-overlay-logo">
                              <div className="menu-ul-small-overlay-logo-logo"></div>
                              <img src={HamburgerMenuClose} className='menu-ul-small-overlay-close-img' alt="logo" onClick={() => setToggleMenu(false)} />
                            </div>
                            <div className='menu-ul-small-overlay-box'>           
                              <div className='menu-ul-small-overlay-link'><Link to="/" onClick={() => setToggleMenu(false)}>Domů</Link></div>
                              <div className='menu-ul-small-overlay-link'><Link to="/PageSluzby" onClick={() => setToggleMenu(false)}>Služby</Link></div>
                              <div className='menu-ul-small-overlay-link'><Link to="/PageProjekty" onClick={() => setToggleMenu(false)}>Projekty</Link></div>
                              <div className='menu-ul-small-overlay-link'><Link to="/PageCertifikaty" onClick={() => setToggleMenu(false)}>Certifikáty</Link></div>
                              <div className='menu-ul-small-overlay-link'><Link to="/PageKontakt" onClick={() => setToggleMenu(false)}>Kontakt</Link></div>
                            </div>
                          </div>
                          )}
        </div>
    </div>

  );
}

export default Header2;
